import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { StaticSearchItem } from '../../models/results-types';
import { StaticSearchItemType } from './static-search-item.model';

@Component({
  selector: 'static-search-item',
  templateUrl: './static-search-item.component.html',
  styleUrls: ['./static-search-item.component.scss'],
})
export class StaticSearchItemComponent {
  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    this.onInvoke.emit(this.model.invokeType);
    event.stopPropagation();
  }

  @Output() onInvoke = new EventEmitter<StaticSearchItemType>();
  @Input() model: StaticSearchItem;
}
